import React from 'react';
import { Badge } from '@/components/ui/badge';

interface Profile {
  is_verified: boolean;
  created_from: 'self_registered' | 'invited';
}

export const ProfileStatusBadge = ({ profile }: { profile: Profile }) => {
  if (profile.is_verified) {
    return <Badge variant="success">Verified</Badge>;
  }
  return <Badge variant="secondary">Unverified</Badge>;
};

export const ProfileCreationBadge = ({ profile }: { profile: Profile }) => {
  if (profile.created_from === 'self_registered') {
    return <Badge variant="outline">Self Registered</Badge>;
  }
  return <Badge variant="outline">Invited</Badge>;
};